import { Button, Grid } from "@mui/material";

export function UpdateApproverButton({ handleOpen, updateDisabled }) {
  return (
    <Grid item>
      <Button
        size="small"
        variant="contained"
        sx={{
          padding: "10px 20px",
          mr: "20px",
          fontSize: "14px",
          backgroundColor: "#c7ab79",
        }}
        disabled={updateDisabled}
        onClick={() => handleOpen()}
      >
        Update Approver
      </Button>
    </Grid>
  );
}
